import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Handle, Position } from "@xyflow/react";
import { useTranslation } from "react-i18next";
import { useNodeVisualState } from "../hooks/useNodeVisualState";
import { getBpmnEventIcon } from "../bpmnEventTypes";
import { START_END_CIRCLE_INSET, START_END_CIRCLE_SIZE, START_END_HANDLE_Y, START_END_HEIGHT, START_END_LABEL_Y, START_END_WIDTH } from "../constants";
import { HandleErrorDot } from "./HandleErrorDot";
export function CircleEventNode({ data, fallbackLabel = "" }) {
    const { t } = useTranslation();
    // Withhold mouse handlers when not clickable so hover state never trips.
    const showInteractionAffordance = data.isClickable && !data.isDimmed;
    const isEdit = data.mode === "edit";
    const { tokens, dimClass, handleMouseEnter, handleMouseLeave } = useNodeVisualState({
        isSelected: data.isSelected,
        isDimmed: data.isDimmed,
        isEdit,
        hasPublishError: data.hasPublishError
    });
    const cursorClass = showInteractionAffordance ? "cursor-pointer" : "";
    // `none` keeps the historical filled-ring look — the outer circle IS the
    // visual. Other event types stroke the ring and center an inner icon.
    const eventType = data.eventType ?? "none";
    const isNoneEvent = eventType === "none";
    const InnerIcon = getBpmnEventIcon(eventType);
    return /*#__PURE__*/ _jsxs("div", {
        className: `group relative text-[12px] transition-opacity duration-200 ${dimClass} ${cursorClass}`,
        style: {
            width: START_END_WIDTH,
            height: START_END_HEIGHT
        },
        onMouseEnter: showInteractionAffordance ? handleMouseEnter : undefined,
        onMouseLeave: showInteractionAffordance ? handleMouseLeave : undefined,
        children: [
            /*#__PURE__*/ _jsx(Handle, {
                type: "source",
                position: Position.Right,
                style: {
                    top: START_END_HANDLE_Y,
                    zIndex: 10
                },
                isConnectable: isEdit
            }),
            /*#__PURE__*/ _jsx(Handle, {
                type: "target",
                position: Position.Left,
                isConnectable: false,
                style: {
                    top: START_END_HANDLE_Y,
                    opacity: 0,
                    pointerEvents: "none"
                }
            }),
            data.isDisconnected && /*#__PURE__*/ _jsx(HandleErrorDot, {
                top: START_END_HANDLE_Y,
                zIndex: 11,
                label: t("processFlowEditor.eventDisconnected")
            }),
            /*#__PURE__*/ _jsx("div", {
                className: `absolute rounded-full border-2 flex items-center justify-center ${tokens.ringClass}`,
                style: {
                    left: START_END_CIRCLE_INSET,
                    top: START_END_CIRCLE_INSET,
                    width: START_END_CIRCLE_SIZE,
                    height: START_END_CIRCLE_SIZE,
                    borderColor: tokens.stroke,
                    backgroundColor: tokens.fill
                },
                children: !isNoneEvent && /*#__PURE__*/ _jsx(InnerIcon, {
                    size: 24,
                    strokeWidth: 2,
                    stroke: tokens.stroke,
                    className: "pointer-events-none"
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "absolute left-1/2 transform -translate-x-1/2 text-center",
                style: {
                    top: START_END_LABEL_Y,
                    width: 140,
                    wordBreak: "break-word",
                    hyphens: "auto"
                },
                children: data.label || fallbackLabel
            })
        ]
    });
}

//# sourceMappingURL=CircleEventNode.js.map